var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 56,
    viewBox: "0 0 61 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2384_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.281 8.44623H45.1764L43.3365 3.15037C43.0891 2.43922 42.6265 1.82269 42.0129 1.38628C41.3993 0.949873 40.6651 0.715212 39.9122 0.714844H21.6649C20.9079 0.714691 20.1698 0.951586 19.5544 1.39228C18.9389 1.83297 18.4769 2.45533 18.2331 3.17201L16.438 8.44623H6.3447C5.6239 8.44704 4.93285 8.73373 4.42317 9.24342C3.91348 9.7531 3.62679 10.4442 3.62598 11.165V46.5084C3.62679 47.2292 3.91348 47.9203 4.42317 48.43C4.93285 48.9396 5.6239 49.2263 6.3447 49.2271H55.281C56.0018 49.2263 56.6929 48.9396 57.2026 48.43C57.7122 47.9203 57.9989 47.2292 57.9997 46.5084V11.165C57.9989 10.4442 57.7122 9.7531 57.2026 9.24342C56.6929 8.73373 56.0018 8.44704 55.281 8.44623ZM54.3748 45.6022H7.25174V12.0712H19.034L21.6649 4.33981H39.9122L42.598 12.0712H54.3748V45.6022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8124 14.7891C28.2583 14.7891 25.7615 15.5465 23.6378 16.9655C21.5141 18.3845 19.8589 20.4013 18.8815 22.7611C17.904 25.1208 17.6483 27.7173 18.1466 30.2224C18.6449 32.7275 19.8748 35.0285 21.6809 36.8346C23.4869 38.6406 25.788 39.8706 28.293 40.3688C30.7981 40.8671 33.3946 40.6114 35.7544 39.634C38.1141 38.6565 40.131 37.0013 41.55 34.8776C42.969 32.7539 43.7264 30.2572 43.7264 27.703C43.7225 24.2792 42.3606 20.9968 39.9396 18.5758C37.5187 16.1548 34.2362 14.793 30.8124 14.7891ZM30.8124 36.992C28.9752 36.992 27.1793 36.4472 25.6517 35.4265C24.1242 34.4058 22.9336 32.9551 22.2305 31.2578C21.5274 29.5604 21.3435 27.6927 21.7019 25.8908C22.0603 24.0889 22.945 22.4338 24.2441 21.1347C25.5432 19.8356 27.1983 18.9509 29.0002 18.5925C30.8021 18.2341 32.6698 18.4181 34.3671 19.1211C36.0645 19.8242 37.5152 21.0148 38.5359 22.5423C39.5566 24.0699 40.1014 25.8658 40.1014 27.703C40.0986 30.1658 39.119 32.5268 37.3776 34.2682C35.6362 36.0097 33.2751 36.9892 30.8124 36.992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2384_8",
    x: 0.625977,
    y: 0.714844,
    width: 60.374,
    height: 54.5117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2384_8"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2384_8",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIco);
export default __webpack_public_path__ + "static/media/camera_ico.a31e9f621b99d57a1cc5edc81bc72b80.svg";
export { ForwardRef as ReactComponent };